import { render } from "./PageLayoutWithTopBar.vue?vue&type=template&id=fb92fcc6&scoped=true"
import script from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"
export * from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"

import "./PageLayoutWithTopBar.vue?vue&type=style&index=0&id=fb92fcc6&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb92fcc6"]])

export default __exports__